import styled from 'styled-components';
import { BodyRegularS, DefaultButton } from '../../styles/globals';
import { IThemeProvider, ITheme } from '../../styles/theme';

interface IAddPartiNewFormCont {
  theme: ITheme;
  error?: boolean;
}
export const AddPartiNewFormCont = styled.form<IAddPartiNewFormCont>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border-radius: 8px;
  box-sizing: border-box;
  ${({ theme, error }: IAddPartiNewFormCont) => `
    padding: 0 ${theme.layout.spacing.centy};
    background: ${theme.colors.primary[10]};
    margin: 0 0 ${theme.layout.spacing.mikro} 0;
    height: ${error ? '90px' : '80px'};
 `}
`;

export const AddFormCell = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: calc(100% - 400px);
`;

export const FormButtonsCont = styled.div`
    position: relative;
    display: flex;
`;

export const SaveButton = styled(DefaultButton)`
  width: auto;
  outline: none;
  border: none;
  border-radius: 8px;
  ${({ theme }: IThemeProvider) => `
    padding: 0 ${theme.layout.spacing.decy};
    background: ${theme.colors.primary[100]};
    color: ${theme.colors.neutral.primary[5]};
  `}
`;

export const SaveAndAddButton = styled(SaveButton)`
  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.mikro} 0 0;
    padding: 0 ${theme.layout.spacing.centy};
    background:${theme.colors.neutral.primary[0]};
    border: 2px solid ${theme.colors.primary[100]};
    color: ${theme.colors.primary[100]};
  `}
`;

export const CancelButton = styled(SaveAndAddButton)`
  background: transparent;
  border: none;
`;

export const EmailInfoCont = styled.div`
  position: absolute;
  right: 40px;
  top: 15px;
`;

export const EmailValue = styled(BodyRegularS)`
  ${({theme} : IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;
